import type { RequestException } from '@eika-infrastruktur/request';
import type { CreateShareSavingsAccountForChildProcess } from '@generated-types';
import { getProcess } from '@react-query/services/process';
import { useQuery } from '@tanstack/react-query';
import type { ProcessId } from '@types';
import { formatProcessPersonNames } from '@utils/name-utils';
import { useParams } from 'react-router-dom';

export const useProcess = (explicitProcessId?: ProcessId) => {
    const { processId: implicitProcessId } = useParams();

    const processId = explicitProcessId ?? implicitProcessId;

    return useQuery<CreateShareSavingsAccountForChildProcess, RequestException>({
        queryKey: ['process', processId],
        // biome-ignore lint/style/noNonNullAssertion: <Can use because of enabled flag>
        queryFn: () => getProcess(processId!),
        enabled: typeof processId === 'string',
        select: formatProcessPersonNames,
    });
};
